<template>
  <div>
    <SearchBar
      :search-result="searchResult"
      @pagination="pagination"
      @search="search"
      @inputKeyword="inputKeyword"
      class="mt-2"
      placeholder="名前・所属・メールアドレス"
    >
      <v-select
        :items="isExpireOnlyFilterList"
        v-model="isExpireOnlyFilter"
        item-text="text"
        style="max-width: 200px;"
        return-object
      />
      <div class="belong-to-select-container">
        所属先
        <v-select
          :items="getFilterItems()"
          v-model="selectedBelongTypeFilter"
          item-text="text"
          class="belong-to-select"
          return-object
        />
      </div>
    </SearchBar>
    <v-data-table
      :headers="headers"
      :items="invitationList"
      :loading="loading.searchInvitationsResult"
      :disable-initial-sort="true"
      hide-actions
      class="elevation-1 mt-2"
    >
      <template #headers="props">
        <th
          v-for="header in props.headers"
          :key="header.text"
          :class="[
            'column sortable px-2 py-0',
            sortOptions.descending ? 'desc' : 'asc',
            header.value === sortOptions.sortBy ? 'active' : '',
            header.align === 'center' ? 'text-xs-center' : '',
            header.align === 'right' ? 'text-xs-right' : '',
            header.align === 'left' ? 'text-xs-left' : '',
          ]"
          :aria-sort="header.sortable ? '' : 'none'"
          @click="onChangeSort(header)"
        >
          {{ header.text }}
          <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
        </th>
      </template>
      <template slot="items" slot-scope="props">
        <tr>
          <td class="text-xs-left no-wrap">
            <v-btn
              @click="openModalReInvite(props.item)"
              small
              color="primary"
              class="mr-2 ml-0"
              >再招待</v-btn
            >
            <v-btn
              @click="openModalCancelInvite(props.item.id)"
              small
              color="primary"
              class="ma-0"
              >削除</v-btn
            >
          </td>
          <td class="text-xs-left no-wrap">
            <div :class="`${props.item.isExpired ? 'error-text' : ''}`">
              {{ props.item.isExpired ? '期限切れ' : props.item.limitTime }}
            </div>
          </td>
          <td class="text-xs-left no-wrap">{{ props.item.name }}</td>
          <td class="text-xs-left no-wrap">
            <BelongType :value="props.item.belongType" />
            {{ props.item.belongName }}
          </td>
          <td class="text-xs-left no-wrap">{{ props.item.email }}</td>
          <td class="text-xs-left no-wrap">
            {{ japanese.userType[props.item.userType] }}
          </td>
          <td class="text-xs-left no-wrap">{{ props.item.registeredTime }}</td>
        </tr>
      </template>
    </v-data-table>
    <ModalReInvite
      v-model="isOpenReInviteModal"
      :loading="loading"
      :invitation="currentItem"
      :system-owner-list="systemOwnerList"
      :agency-list="agencyList"
      :advertiser-list="advertiserList"
      :search="search"
    />
  </div>
</template>

<script>
import SearchBar from '@/components/Shared/Search/SearchBar'
import BelongType from '@/components/Shared/Presentation/BelongType'
import ModalReInvite from '@/components/Admin/Account/ModalReinvite.vue'
import japanese from '@/constants/japanese'
import dayjs from 'dayjs'
export default {
  name: 'InvitationList',
  components: {
    SearchBar,
    BelongType,
    ModalReInvite,
  },
  props: {
    loading: {
      type: Object,
      default: () => {},
    },
    searchResult: {
      type: Object,
      default: () => {},
    },
    userBelongType: {
      type: String,
      default: '',
    },
    userBelongId: {
      type: [Number, String],
      default: 0,
    },
    userType: {
      type: String,
      default: '',
    },
    systemOwnerList: {
      type: Array,
      default: () => [],
    },
    agencyList: {
      type: Array,
      default: () => [],
    },
    advertiserList: {
      type: Array,
      default: () => [],
    },
    adminAgencyList: {
      type: Array,
      default: () => [],
    },
    agencyListForSearch: {
      type: Array,
      default: () => [],
    },
    agencyAuthChain: {
      type: Object,
      default: () => {},
    },
    adminAdvertiserList: {
      type: Array,
      default: () => [],
    },
    advertiserListForSearch: {
      type: Array,
      default: () => [],
    },
    advertiserAuthChain: {
      type: Object,
      default: () => {},
    },
    dispatchGetAgencyAccountAuth: {
      type: Function,
      default: () => [],
    },
    dispatchGetAdvertiserAccountAuth: {
      type: Function,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        { text: '編集/削除', value: 'operation' },
        { text: '登録期限', value: 'limitTime', sortable: true },
        { text: '名前', value: 'name', sortable: true },
        { text: '所属先', value: 'belongName' },
        { text: 'メールアドレス', value: 'email' },
        { text: 'ユーザ種別', value: 'userType' },
        { text: '招待日時', value: 'registeredTime', sortable: true },
      ],
      isExpireOnlyFilterList: [
        { text: 'すべての招待を表示', value: false },
        { text: '期限切れの招待のみ表示', value: true },
      ],
      isExpireOnlyFilter: { text: 'すべての招待を表示', value: false },
      selectedBelongTypeFilter: { text: 'すべて表示', value: 'all' },
      userBelongTypes: [],
      dayjs,
      isOpenReInviteModal: false,
      currentItem: undefined,
      japanese,
      sortOptions: {
        sortBy: 'limitTime',
        descending: true,
      },
    }
  },
  computed: {
    invitationList() {
      return this.searchResult.items.map(invitation => ({
        ...invitation,
        isExpired: dayjs(invitation.limitTime).isBefore(dayjs()),
      }))
    },
  },
  watch: {
    userBelongId() {
      this.initSearch()
    },
    selectedBelongTypeFilter() {
      this.search()
    },
    isExpireOnlyFilter() {
      this.search()
    },
    userType() {
      console.log(this.userType)
    },
  },
  mounted() {
    this.initSearch()
  },
  methods: {
    initSearch() {
      this.search()
    },
    inputKeyword(keyword) {
      this.searchKeyword = keyword
    },
    onChangeSort(header) {
      if (!header.sortable) return

      const column = header.value

      if (this.sortOptions.sortBy === column) {
        this.sortOptions.descending = !this.sortOptions.descending
      } else {
        this.sortOptions.sortBy = column
        this.sortOptions.descending = false
      }

      this.search()
    },

    pagination(e) {
      this.search(e)
    },
    search(pageNo) {
      const belongType = (() => {
        if (this.selectedBelongTypeFilter.value === 'all') return undefined
        return this.selectedBelongTypeFilter.value
      })()
      const isExpiredOnly = (() => {
        if (!this.isExpireOnlyFilter.value) return undefined
        return this.isExpireOnlyFilter.value
      })()
      const params = {
        keyword: this.searchKeyword,
        belongType: belongType,
        isExpiredOnly: isExpiredOnly,
        sortKey: this.sortOptions.sortBy,
        sortDirection: this.sortOptions.descending ? 'desc' : 'asc',
        pageNo: pageNo || 1,
      }
      this.$emit('search', params)
    },
    retrySearch() {
      const params = {
        keyword: this.searchKeyword,
        pageNo: this.searchResult.pageNo,
      }
      this.$emit('search', params)
    },
    async openModalCancelInvite(deleteInvitationId) {
      const confirmed = await this.$confirm(undefined, {
        body:
          '招待情報を削除しますがよろしいですか？\n※登録期限内の場合、招待メールに記載されているURLは、無効となります。',
        okText: '削除',
        cancelText: 'キャンセル',
      })

      if (confirmed) {
        await this.$emit('cancelInvite', deleteInvitationId)
        this.search()
      }
    },
    openModalReInvite(item) {
      this.currentItem = item
      this.isOpenReInviteModal = true
    },
    openModalChangePermission(item) {
      if (!this.canEditPermission(item)) {
        this.openModalReInviteError()
        return
      }
      const belongType = item.belongType
      switch (belongType) {
        case 'advertiser':
          // accountタイプによって開くmodalを分岐させる
          this.$refs.editAdvertiserAccountAuthModal.prepare(item)
          break
        case 'agency':
          // accountタイプによって開くmodalを分岐させる
          this.$refs.editAgencyAccountAuthModal.prepare(item)
          break
      }
    },
    canEditPermission(item) {
      if (this.userBelongType === 'system owner') return true
      else if (this.userBelongType === 'agency') {
        return (
          (this.userType === 'administrator' &&
            ((item.belongType === 'agency' &&
              item.userType !== 'administrator') ||
              item.belongType === 'advertiser')) ||
          (this.userType !== 'administrator' &&
            item.belongType === 'advertiser' &&
            item.userType !== 'advertiser')
        )
      } else if (this.userBelongType === 'advertiser') {
        return (
          this.userType === 'administrator' &&
          item.belongType === 'advertiser' &&
          item.userType !== 'administrator'
        )
      }
      return false
    },
    getFilterItems() {
      switch (this.userBelongType) {
        case 'system owner':
          return [
            { text: 'すべて表示', value: 'all' },
            { text: 'システムオーナーのみ表示', value: 'systemOwner' },
            { text: '代理店のみ表示', value: 'agency' },
            { text: '広告主のみ表示', value: 'advertiser' },
          ]
        case 'agency':
          return [
            { text: 'すべて表示', value: 'all' },
            { text: '代理店のみ表示', value: 'agency' },
            { text: '広告主のみ表示', value: 'advertiser' },
          ]
        case 'advertiser':
          return [{ text: 'すべて表示', value: 'all' }]
        default:
          return []
      }
    },
  },
}
</script>

<style scoped>
.no-wrap {
  white-space: nowrap;
}
.title {
  font-weight: normal;
  color: #614545;
}
.selection {
  max-width: 240px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.belong-to-select-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 20px;
}
.belong-to-select {
  max-width: 200px;
  margin-left: 10px;
}
.error-text {
  color: #ff0000;
}
</style>
